<template>
  <div
    class="modal fade fill-in disable-scroll mt-10"
    id="modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="false"
  >
    <div class="modal-dialog modal-confirm modal-lebar modal-xl">
      <div class="modal-content">
        <div
          class="modal-header pt-1 pb-0 d-flex bg-white rounded-top"
          style="height: 2rem"
        >
          <div
            class="shade ml-auto clickable hoverable bg-white"
            style="
              margin-right: -30px;
              margin-top: -15px;
              height: 2rem;
              width: 2rem;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <i
              class="bi bi-x"
              style="font-size: 30px"
              data-dismiss="modal"
              @click.prevent="closeModal"
            ></i>
          </div>
        </div>
        <div v-if="is_loading">
          <div class="bg-white rounded py-5">
            <loader_component />
          </div>
        </div>
        <div v-else>
          <div class="modal-body bg-white pt-0 pb-3 rounded-bottom">
            <h4 class="pt-0 mt-0">Postingan Terbaru</h4>
            <div v-if="posts" class="scroller" style="max-height: 30rem">
              <post-list-simple-component
                :posts="posts"
                :show_topik="true"
                :topics="topics"
                :is_title_clicked="false"
              />
              <div
                class="row mt-4"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  margin-left: 0px !important;
                  margin-right: 0px !important;
                "
              >
                <div class="col-md-6">
                  {{ paginationInfo() }}
                </div>
                <div class="col-md-6 p-l-1 p-r-0">
                  <pagination-component
                    v-if="page_info"
                    :data="page_info"
                    :goto="true"
                    class="pull-right"
                  />
                </div>
              </div>
            </div>
            <div v-else>
              <div class="bg-white rounded pt-3 pb-0">
                <div class="alert alert-warning">
                  <h5><center>Postingan tidak tersedia</center></h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix" />
      <!-- <div class="modal-footer bg-white rounded-bottom" /> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import loader_component from "@/views/components/loader.vue";
import post_list_simple from "@/views/components/post_list_simple.vue";
import pagination_component from "@/views/components/pagination.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "modal_account_post",
  components: {
    loader_component,
    "post-list-simple-component": post_list_simple,
    "pagination-component": pagination_component,
  },
  props: { id_account: String },
  data() {
    return {
      is_loading: true,
      id_project: this.$store.getters.user.id_project,
      posts: null,
      page_info: null,
      current_page: 1,
      topics: null,
    };
  },
  methods: {
    getPosts: function () {
      let self = this;
      self.is_loading = true;
      let params = {
        id_account: "https://twitter.com/" + self.id_account,
        from: self.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        to: self.$store.getters.filter_date_to.format("YYYY-MM-DD HH:mm:ss"),
        page: self.current_page,
      };
      if ("topic_selected" in self.$route.query) {
        params.topic_selected = self.$route.query.topic_selected;
      }
      if ("group" in self.$route.query) {
        params.group = self.$route.query.group;
      }
      if ("is_validated" in self.$route.query) {
        params.is_validated = self.$route.query.is_validated;
      }
      if ("cakupan" in self.$route.query) {
        params.cakupan = self.$route.query.cakupan;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL +
        "posts-dev/" +
        self.id_project +
        "?" +
        query;
      this.$http
        .get(api, params)
        .then(function (response) {
          if (response.status == 200) {
            self.posts = response.data.posts;
            self.page_info = response.data.page_info;
          } else {
            self.posts = null;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.is_loading = false;
        });
    },
    closeModal: function (event) {
      var $trigger = $(".modal-lebar");
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        this.$parent.isShowModal = false;
      }
      let query = Object.assign({}, this.$route.query);
      if (query.page) {
        delete query.page;
        this.$router.replace({ query });
      }
    },
    thousandSeparator(val) {
      return gp.thousandSeparator(val);
    },
    paginationInfo: function () {
      let text = "";
      if (this.page_info != null) {
        let data_start =
          this.page_info.limit * this.page_info.page -
          (this.page_info.limit - 1);
        let data_end = this.page_info.limit * this.page_info.page;
        if (data_end > this.page_info.total) {
          data_end = this.page_info.total;
        }
        text =
          "Menampilkan " +
          data_start +
          " - " +
          data_end +
          " dari " +
          this.thousandSeparator(this.page_info.total);
      }

      return text;
    },
    getTopic: function () {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status == 204) {
            self.topics = {};
          } else {
            self.topics = response.data;
          }
        })
        .catch(function () {
          self.topics = {};
        })
        .finally(() => {
          this.getPosts();
        });
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2 || user_role == 3) {
        return true;
      }

      return false;
    },
  },
  created: async function () {
    this.$.pgNotification = notif;
    this.getTopic();
  },
  mounted: function () {
    $("#modal").modal("show");
  },
  watch: {
    $route() {
      if (this.$route.query.page) {
        this.current_page = this.$route.query.page;
      }
      this.getPosts();
    },
  },
};
</script>
<style scoped>
@import "../../../../public/assets/plugins/bootstrap-social/bootstrap-social.css";
.modal.fade.fill-in > .close > i {
  font-size: 60px;
}
.modal-lebar {
  width: 70% !important;
}
</style>
